import { client } from '@/services/apolloclient'
import reportList from '../../router/views/report/lib/reportList'
import { GET_SAVED_REPORT, GET_FAVORITE_REPORTS } from '@/services/api/report/report'
import moment from 'moment'

export const state = {
  downloadProcess: [],
  percentageProcess: [0, 25, 50, 75, 90, 100],
  index: 0,
  failedDownload: [],
  successDownload: [],
  isGraphOpen: true,
  isPopupDownload: false,
  reports: [...reportList],
  filterReport: {},
  vehicleFilter: new Map(),
  filterValue: {},
  expensesFilter: {
    created_on: [],
  },
  fleetUtilizationFilter: {
    created_on: [],
  },
  fleetUtilizationFullObjects:
    JSON.parse(localStorage.getItem('fleetUtilizationFullObjects')) || {},
  driverFilter: new Map(),
  geofenceFilter: new Map(),
  transaction_date: [],
  savedReports: [],
  vehicleFilterList: {
    list: [],
    loaded: false,
  },
  geofenceFilterList: {
    list: [],
    loaded: false,
  },
  driverFilterList: {
    list: [],
    loaded: false,
  },
  alertFilterList: {
    list: [],
    loaded: false,
  },
}

export const getters = {
  showAll: (state) => state.downloadProcess,
  showProgress: (state) => {
    var percentageArr = state.downloadProcess.map((item) => item.percentage)
    var sum = percentageArr.reduce((partialSum, a) => partialSum + a, 0)

    if (sum == 0 || percentageArr.length == 0) {
      return 0
    }
    return sum / percentageArr.length
  },
}

export const actions = {
  async setSavedReport({ commit, state }) {
    await client
      .query({
        query: GET_SAVED_REPORT,
        fetchPolicy: 'no-cache',
      })
      .then((res) => {
        if (res.data) {
          const reports = state.reports
          const getReport = (reportKey) => {
            const report = reports.find((item) => item.key == reportKey)
            return report
          }
          const transformPeriode = (filter, dateType, reportKey) => {
            if (!dateType) return filter
            switch (dateType) {
              case 'today': {
                const dateStart = new Date()
                dateStart.setHours(0, 0, 0, 0)
                filter.periode = [dateStart, new Date()]
                break
              }
              case 'yesterday': {
                const dateStart = new Date()
                const dateEnd = new Date()
                dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24)
                dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24)
                dateStart.setHours(0, 0, 0, 0)
                dateEnd.setHours(23, 59, 59, 999)
                filter.periode = [dateStart, dateEnd]
                break
              }
              case 'last3days': {
                const dateStart = new Date()
                dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * 2)
                dateStart.setHours(0, 0, 0, 0)
                filter.periode = [dateStart, new Date()]
                break
              }
              case 'last7days': {
                const dateStart = new Date()
                dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * 6)
                dateStart.setHours(0, 0, 0, 0)
                filter.periode = [dateStart, new Date()]
                break
              }
              case 'last31days': {
                const dateStart = new Date()
                dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * 30)
                dateStart.setHours(0, 0, 0, 0)
                filter.periode = [dateStart, new Date()]
                break
              }
            }
            if (
              reportKey !== 'detail-history-vehicle' &&
              reportKey !== 'fuel' &&
              reportKey !== 'temperature' &&
              reportKey !== 'alert'
            ) {
              filter.periode[0] = moment(filter.periode[0]).format('YYYY-MM-DD')
              filter.periode[1] = moment(filter.periode[1]).format('YYYY-MM-DD')
            }
            return filter
          }
          const savedReports = []
          res.data.savedReports.savedReports.forEach((item) => {
            const report = getReport(item.reportKey)
            if (report) {
              const data = {
                savedId: item.savedReportsId,
                key: `saved-${item.reportKey}-${item.savedReportsId}`,
                reportKey: item.reportKey,
                labelName: item.reportName,
                modal: `saved-report-modal-${item.savedReportsId}`,
                table: `savedReport${item.savedReportsId}`,
                event: `Saved ${report.event}`,
                desc: item.description ? item.description : report.desc,
                isDescDefault: item.description ? false : true,
                link: report.link,
                isFavorite: false,
                isSaved: true,
                domain: report.domain,
                category: report.category,
                section: report.section,
                filter: report.filter,
                filterValue: transformPeriode(
                  JSON.parse(item.filter),
                  item.dateType,
                  item.reportKey
                ),
                dateType: item.dateType,
                downloadOptions: report.downloadOptions,
                schedulerEnum: report.schedulerEnum,
              }
              savedReports.push(data)
            }
          })
          localStorage.setItem('saveReports', JSON.stringify(savedReports))
          commit('updateSavedReport', savedReports)
        }
      })
  },

  async setFavoriteReport({ commit, state }) {
    let reportList = state.reports
    await client
      .query({
        query: GET_FAVORITE_REPORTS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            type: 'report',
          },
        },
      })
      .then((res) => {
        if (res.data) {
          const reportKeys = res.data.favoriteReports.favoriteReports.favoriteReportKeys
          reportList.forEach((item, index) => {
            if (reportKeys.includes(item.key)) {
              reportList[index].isFavorite = true
            }
          })
        }
      })
    commit('updateReportList', reportList)
  },
}

export const mutations = {
  saveProgress(state, payload) {
    state.downloadProcess.push(payload)
  },
  deleteProgress(state, payload) {
    var index = state.downloadProcess.indexOf(payload)
    if (index !== -1) {
      state.downloadProcess.splice(index, 1)
    }
  },
  updateProgress(state, payload) {
    var index = state.downloadProcess.indexOf(payload.progress)
    if (index !== -1) {
      state.downloadProcess[index].percentage = payload.percentage
    }
  },
  doneProgress(state, payload) {
    state.successDownload.push(payload)
  },
  removeAllProgress(state) {
    state.downloadProcess = []
  },
  changeGraphStatus(state, payload) {
    state.isGraphOpen = !payload
  },
  showDownloadPopup(state, payload) {
    state.isPopupDownload = payload
  },
  updateReportList(state, payload) {
    state.reports = payload
  },
  updateFilter(state, payload) {
    state.filterReport = payload
  },
  setMapVehicleFilter(state, payload) {
    state.vehicleFilter = payload
  },
  updateFilterValue(state, payload) {
    state.filterValue = payload
  },
  updateExpensesFilter(state, payload) {
    state.expensesFilter = payload
  },
  updateFleetUtilizationFilter(state, payload) {
    state.fleetUtilizationFilter = payload
  },
  updateFleetUtilizationFullObjects(state, payload) {
    state.fleetUtilizationFullObjects = payload
    localStorage.setItem('fleetUtilizationFullObjects', JSON.stringify(payload))
  },
  setMapDriverFilter(state, payload) {
    state.driverFilter = payload
  },
  setMapGeofenceFilter(state, payload) {
    state.geofenceFilter = payload
  },
  updateSavedReport(state, payload) {
    state.savedReports = payload
  },
  updateVehicleFilterList(state, payload) {
    state.vehicleFilterList = payload
  },
  updateGeofenceFilterList(state, payload) {
    state.geofenceFilterList = payload
  },
  updateDriverFilterList(state, payload) {
    state.driverFilterList = payload
  },
  updateAlertFilterList(state, payload) {
    state.alertFilterList = payload
  },
}
